import { Requests } from "../common/request.common";
import { AgencyWaResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const agencyWa = {
    queueRecord(data: typeof Requests.AgencyWa.QueueRecord.Input) {
        return post<typeof data, AgencyWaResponseTypes.QueueRecord>(
            "/agency-wa/queue-record",
            data,
        );
    },
    login() {
        return postEmpty<AgencyWaResponseTypes.Login>("/agency-wa/login");
    },
    logout() {
        return postEmpty("/agency-wa/logout");
    },
    obtain() {
        return get<AgencyWaResponseTypes.Obtain>("/agency-wa/obtain");
    },
};
